<nz-list-item-meta>
  <nz-list-item-meta-title>
    <!-- Plan V1 Template -->
    <ng-container *ngIf="isPlanV1; else planV2DisplayNameTpl">
      <span
        nz-tooltip
        nzTooltipPlacement="topLeft"
        [nzTooltipTitle]="plan['displayName']"
      >
        {{ plan['displayName'] }}
      </span>
      <nz-tag>
        {{ 'GLOBAL_TERMS.PLANS.CLASS.' + plan['class'] | translate }}
      </nz-tag>

    </ng-container>

    <!-- Plan V2 Template -->
    <ng-template #planV2DisplayNameTpl>
      <span
        nz-tooltip
        nzTooltipPlacement="topLeft"
        [nzTooltipTitle]="plan?.planDisplayName"
      >
        {{ plan?.planDisplayName }}
      </span>
      <nz-tag>
        {{ 'GLOBAL_TERMS.PLANS.CLASS.' + plan?.planClass | translate }}
      </nz-tag>
    </ng-template>
  </nz-list-item-meta-title>
</nz-list-item-meta>

<ul nz-list-item-actions>
  <nz-list-item-action *ngIf="plan['capacity']; else generalCapacityTpl">
    <i class="fal fa-save"></i>
    <span>
      {{
        plan['capacity']
          | utils: "convertKibByte"
          | numberFormatter: "'0.0ib'"
          | ibFix
      }}
    </span>
  </nz-list-item-action>
  <!-- If "capacity" property isn't returned, take traffic label's general capacity -->
  <ng-template #generalCapacityTpl>
    <nz-list-item-action>
      <i class="fal fa-save"></i>
      <span>
        {{
          generalCapacity
            | utils: "convertKibByte"
            | numberFormatter: "'0.0ib'"
            | ibFix
        }}
      </span>
    </nz-list-item-action>
  </ng-template>

  <nz-list-item-action
    *ngIf="plan?.duration || plan?.durationType === PlanRecurrenceType.MONTHLY"
  >
    <i class="fal fa-clock"></i>
    <span>
      <!-- Plan V1 Template -->
      <ng-container *ngIf="isPlanV1; else planV2DurationTpl">
        <ng-container *ngIf="
          plan['recurrenceType'] === PlanRecurrenceType.MONTHLY;
          else dailyRecurrence
        ">
          {{ "GLOBAL_TERMS.ONE_MONTH" | translate }}
        </ng-container>
      </ng-container>

      <!-- Plan V2 Template -->
      <ng-template #planV2DurationTpl>
        <ng-container *ngIf="
            plan?.durationType === PlanRecurrenceType.MONTHLY;
            else dailyRecurrence
          ">
          {{ "GLOBAL_TERMS.ONE_MONTH" | translate }}
        </ng-container>
      </ng-template>

      <ng-template #dailyRecurrence>
        {{ plan?.duration | utils: "convertSecToMs" | msConvert }}
      </ng-template>
    </span>
  </nz-list-item-action>

  <nz-list-item-action *ngIf="plan?.finalPrices && plan?.finalPrices.length > 0">
    <!-- Plan V1 Template -->
    <ng-container *ngIf="isPlanV1; else planV2FinalPricesTpl">
      <span>
        {{
          plan?.finalPrices[0]['finalPrice'] || 0
            | utils: "convertToDollars"
            | oxioCurrency: true
        }}
      </span>
      <span>{{ plan?.finalPrices[0]['currency'] }}</span>
    </ng-container>

    <!-- Plan V2 Template -->
    <ng-template #planV2FinalPricesTpl>
      <span>
        {{
          plan?.finalPrices[0]?.amount || 0
            | utils: "convertToDollars"
            | oxioCurrency: true
        }}
      </span>
      <span>{{ plan?.finalPrices[0]?.amountCurrency }}</span>
    </ng-template>
  </nz-list-item-action>

  <nz-list-item-action *ngIf="(plan?.trafficLabels
      | utils:'filterTrafficLabelsBySpeed':DataControlType.LOW_SPEED_DATA)?.length > 0">
    <app-social-v2
      [socialData]="plan?.trafficLabels
        | utils:'filterTrafficLabelsBySpeed':DataControlType.LOW_SPEED_DATA"
      [showCapacities]="true"
    ></app-social-v2>
  </nz-list-item-action>

  <nz-list-item-action
    *ngIf="isGrantPlanFormType && plan.eligibility && plan.eligibility !== EligibilityType.NOT_ELIGIBLE"
  >
    <span
      nz-typography
      [nzType]="eligibilityStyle[plan.eligibility]"
    >
      <span [ngClass]="plan.eligibility">
        <i class="fal fa-usd-circle"></i>
        {{
          'PAGE.MOBILE.END_USERS.GRANT_PLAN.CONSUMER_PLAN.ELIGIBILITY.' + plan.eligibility
            | translate
        }}
      </span>
    </span>
  </nz-list-item-action>
</ul>
